import { defineStore } from 'pinia';

export const useErrorStore = defineStore('error', {
  state: () => ({
    message: '',
  }),
  actions: {
    setMessage(msg: string) {
      this.message = msg;
    },
    clearMessage() {
      this.message = '';
    }
  }
});
